export default __webpack_public_path__ + "static/media/save_caution_no_matte.564fe62e.svg";